module.exports = __webpack_public_path__ + "img/bullet_6.85be7979.svg";